<template>
  <div class="flex flex-row p-2 mt-2 gap-x-2">
    <Input
      v-if="isShowInput"
      :label-top="true"
      :label="`P (Auto)`"
      :value="inputValue"
      :disabled="true"
    />

    <Input
      v-if="showOtherForm"
      :label-top="true"
      :label="`Tanggal Transaksi`"
      :value="formatDate"
      :disabled="true"
    />

    <Input
      :label="'Nama Bank'"
      :label-top="true"
      :disabled="true"
      :value="bankName"
    />

    <Input
      :label="'Rek Debet'"
      :label-top="true"
      :disabled="true"
      :value="rekDebet"
    />

    <Input
      :label="'Total Record'"
      :label-top="true"
      :disabled="true"
      :value="totalRecord"
    />

    <Input
      :label="'Total Amount'"
      :label-top="true"
      :disabled="true"
      :value="totalAmount"
    />
  </div>
</template>

<script>
import Input from "@/components/Input.vue";
import moment from "moment";
export default {
  name: "DetailBank",
  components: {
    Input,
  },
  props: {
    isShowInput: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: String,
      required: true,
    },
    companyId: {
      type: String,
      default: "",
    },
    bankName: {
      type: String,
      required: true,
      default: "",
    },
    rekDebet: {
      type: String,
      required: true,
      default: "",
    },
    totalRecord: {
      type: Number,
      required: true,
      default: 0,
    },
    totalAmount: {
      type: String,
      required: true,
      default: "",
    },
    date: {
      type: String,
      required: true,
    },
    showOtherForm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formatDate() {
      return moment(this.date).format("YYYYMMDD");
    },
  },
};
</script>
